/**
 * Polylang select wrapper
 * Adds wrapper around select to enable custom arrow icon.
 *
 * Also attaches a change handler to every found select — this is necessary
 * because the template renders get_sidebar('header-right') twice (desktop + mobile),
 * resulting in two <select> elements sharing the same id="lang_choice_polylang-*".
 * Polylang's own JS uses getElementById/jQuery ID selector which matches only the
 * first element (desktop), leaving the mobile select without a handler.
 */
export default function initializePolylangSelect() {
    const polylangSelects = document.querySelectorAll('.widget_polylang .pll-switcher-select');

    polylangSelects.forEach(select => {
        // Sprawdź, czy już nie ma wrappera
        if (select.parentElement.classList.contains('polylang-select-wrapper')) {
            return;
        }

        // Utwórz wrapper
        const wrapper = document.createElement('div');
        wrapper.classList.add('polylang-select-wrapper');

        // Wstaw wrapper przed selectem
        select.parentNode.insertBefore(wrapper, select);

        // Przenieś select do wrappera
        wrapper.appendChild(select);

        // Podepnij handler zmiany języka do każdego selecta (naprawia brakujący
        // listener na mobilnym elemencie spowodowany duplikatem ID w DOM)
        select.addEventListener('change', function () {
            window.location.href = this.value;
        });
    });
}


